import * as countriesList from './countries-list';
import * as alphabets from './alphabets';

export const citizenshipConfig = {
  ...countriesList,
  ...alphabets,
};
